import { render, staticRenderFns } from "./TagLossAccountingCellLink.vue?vue&type=template&id=64068b97"
import script from "./TagLossAccountingCellLink.vue?vue&type=script&lang=js"
export * from "./TagLossAccountingCellLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports